import auth from "../../middlewares/auth";
export const settingsPortionRoute = [
  {
    path: '/settings/portions',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/portion/PortionList'),
    name: 'settings_portion',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/portion/add',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/portion/PortionForm'),
    name: 'settings_portion_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/portion/edit/:id',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/portion/PortionForm'),
    name: 'settings_portion_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  }
];